import {
  differenceInDays,
  format,
  isSameDay,
  isSameYear,
  isYesterday,
  isTomorrow,
  startOfDay,
} from "date-fns";

export interface DateSmartLabels {
  today: string;
  tomorrow: string;
  yesterday: string;
  nextDay: (day: string) => string;
  inDays: (count: number) => string;
}

export function formatDateSmart(date: Date, labels?: DateSmartLabels): string {
  const today = startOfDay(new Date());
  const target = startOfDay(date);

  if (isSameDay(target, today)) {
    return labels?.today ?? "Today";
  }

  if (isTomorrow(target)) {
    return labels?.tomorrow ?? "Tomorrow";
  }

  if (isYesterday(target)) {
    return labels?.yesterday ?? "Yesterday";
  }

  const diff = differenceInDays(target, today);

  // 2–7 days ahead: "Next Wednesday"
  if (diff >= 2 && diff <= 7) {
    const dayName = format(target, "EEEE");
    return labels?.nextDay ? labels.nextDay(dayName) : `Next ${dayName}`;
  }

  // 8–14 days ahead: "In N days"
  if (diff >= 8 && diff <= 14) {
    return labels?.inDays ? labels.inDays(diff) : `In ${diff} days`;
  }

  // Same year: "Mon, Feb 14"
  if (isSameYear(target, today)) {
    return format(target, "EEE, MMM d");
  }

  // Different year: "Mon, Feb 14, 2026"
  return format(target, "EEE, MMM d, yyyy");
}
